import { useSegment } from './useSegment';

/**
 * Segment and GTM tracking abstraction.
 * Can also be used to track other analytics events in the future.
 *
 * @returns {Object} - Returns tracking function.
 */
export function useTracking() {
  const { track: trackSegment } = useSegment();

  function track(event: string, properties?: Record<string, any>) {
    trackSegment(event, properties);
  }

  return {
    track,
  };
}
